var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { formatCurrency } from '../../helpers/currencies';
import cartUtil from '../../helpers/cartUtil';
import { generateUID } from '../../helpers/urlHelpers';
import { convertToTitleCase } from '../baseHelpers';
const AddToCartButton = ({ extraClass, currentBundle, currentAddOns, product, strings, thumbnailArtwork, addOnArtwork, showCustomiseButton, disableBannedWord, giftSetPrefix, bundleComponents, checkoutImage, closeModal, setUniqueID, openModal }) => {
    const [totalPrice, setTotalPrice] = useState(null);
    const [comparePrice, setComparePrice] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [OOSMessage, setOOSMessage] = useState('');
    const [addingToCart, setAddingToCart] = useState(false);
    const partOrder = ['giftset', 'hull', 'lid', 'button', 'strap', 'straw', 'base', 'collar', 'tag', 'emoji', 'monogram'];
    useEffect(() => {
        setDisabled(false);
        setOOSMessage('');
        let newTotalPrice = product.price;
        let newComparePrice = product.compare_at_price;
        function mapPricingForBundle(bundleGroup) {
            for (const component in bundleGroup) {
                bundleGroup[component].forEach((componentProd) => {
                    var _a, _b, _c, _d, _e, _f;
                    if (componentProd.monogramming) {
                        const selectedEmoji = (_a = componentProd.monogramming.emojis) === null || _a === void 0 ? void 0 : _a.find((emoji) => emoji.selected);
                        if (((_b = componentProd.monogramming.value) === null || _b === void 0 ? void 0 : _b.length) > 0 || selectedEmoji) {
                            const price = componentProd.monogramming.price;
                            const compare_at_price = componentProd.monogramming.compare_at_price;
                            newTotalPrice += price;
                            newComparePrice += compare_at_price;
                        }
                    }
                    if (componentProd.monogramming_back) {
                        const selectedEmoji = (_c = componentProd.monogramming_back.emojis) === null || _c === void 0 ? void 0 : _c.find((emoji) => emoji.selected);
                        if (((_d = componentProd.monogramming_back.value) === null || _d === void 0 ? void 0 : _d.length) > 0 || selectedEmoji) {
                            const price = componentProd.monogramming_back.price;
                            const compare_at_price = componentProd.monogramming_back.compare_at_price;
                            newTotalPrice += price;
                            newComparePrice += compare_at_price;
                        }
                    }
                    if (componentProd.selectedVariant.surcharge_price) {
                        newTotalPrice += Number(componentProd.selectedVariant.surcharge_price) * 100.0;
                        newComparePrice += Number(componentProd.selectedVariant.surcharge_price) * 100.0;
                    }
                    if (!componentProd.selectedVariant.available) {
                        setDisabled(true);
                        setOOSMessage(`Unfortunately, we don’t have <span>${componentProd.title}</span> available${((_e = componentProd.selectedVariant.colour_swatch) === null || _e === void 0 ? void 0 : _e.name) ? ` in <span>${(_f = componentProd.selectedVariant.colour_swatch) === null || _f === void 0 ? void 0 : _f.name}</span>` : ''} at the moment.`);
                    }
                });
            }
        }
        currentBundle.forEach((bundleGroup) => {
            mapPricingForBundle(bundleGroup);
        });
        currentAddOns.forEach((addOn) => {
            const price = addOn.price;
            const compare_at_price = addOn.compare_at_price;
            newTotalPrice += price;
            newComparePrice += compare_at_price ? compare_at_price : 0;
            addOn.products.forEach((addOnProd) => {
                if (!addOnProd.selectedVariant.available) {
                    setDisabled(true);
                }
            });
        });
        setTotalPrice(newTotalPrice);
        setComparePrice(newComparePrice);
    }, [currentBundle, currentAddOns]);
    const addBundleComponents = (bundleGroup, groupIndex, timestamp, isAddOns) => {
        let allParts = {};
        for (const component in bundleGroup) {
            const bundleItems = isAddOns ? bundleGroup.products.filter((product) => product.part != 'parent-product') : bundleGroup[component];
            const partDetails = bundleItems.reduce((obj, item) => {
                var _a, _b, _c, _d;
                const inOrder = partOrder.find((word) => item.part.includes(word));
                let partIndex = partOrder.length;
                if (inOrder && inOrder.length) {
                    partIndex = partOrder.indexOf(inOrder);
                }
                // Properties Syntax:
                // [timestamp]___[type]___[group-index]_[part-index]___[part-name]___[selected-variant]
                // Add part
                if (product.has_components) {
                    const itemToAdd = {
                        id: item.selectedVariant.id,
                        properties: {
                            '_customiser-part': `${timestamp}___${isAddOns ? 'add-on-part' : 'part'}___${groupIndex}_${partIndex}___${convertToTitleCase(item.part)}___${item.selectedVariant.title}`,
                        },
                    };
                    // Add surcharge for part
                    if (item.selectedVariant.surcharge_price && Number(item.selectedVariant.surcharge_price) > 0) {
                        itemToAdd['surcharge'] = Number(item.selectedVariant.surcharge_price);
                    }
                    obj[`_${groupIndex}_${item.part}`] = itemToAdd;
                }
                if (item.monogramming && item.monogramming.included) {
                    const selectedEmoji = (_a = item.monogramming.emojis) === null || _a === void 0 ? void 0 : _a.find((emoji) => emoji.selected);
                    if (item.monogramming.value.length || selectedEmoji) {
                        const monogrammingItem = {
                            id: item.monogramming.variant_id,
                            surcharge: item.monogramming.price / 100,
                            properties: {
                                '_customiser-part': `${timestamp}___${isAddOns ? 'add-on-part' : 'part'}___${groupIndex}_91___Monogram___monogram`,
                            },
                        };
                        if (selectedEmoji) {
                            monogrammingItem.properties['Emoji'] = selectedEmoji.name;
                        }
                        if (((_b = item.monogramming.value) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            monogrammingItem.properties['Monogram'] = item.monogramming.value;
                        }
                        obj[`_${groupIndex}_monogram`] = monogrammingItem;
                    }
                }
                // Add monogramming back
                if (item.monogramming_back && item.monogramming_back.included) {
                    const selectedEmoji = (_c = item.monogramming_back.emojis) === null || _c === void 0 ? void 0 : _c.find((emoji) => emoji.selected);
                    if (item.monogramming_back.value.length || selectedEmoji) {
                        const monogrammingBackItem = {
                            id: item.monogramming_back.variant_id,
                            surcharge: item.monogramming_back.price / 100,
                            properties: {
                                '_customiser-part': `${timestamp}___${isAddOns ? 'add-on-part' : 'part'}___${groupIndex}_92___Monogram___monogram-back`,
                            },
                        };
                        if (selectedEmoji) {
                            monogrammingBackItem.properties['Emoji Back'] = selectedEmoji.name;
                        }
                        if (((_d = item.monogramming_back.value) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                            monogrammingBackItem.properties['Monogram Back'] = item.monogramming_back.value;
                        }
                        obj[`_${groupIndex}_monogram-back`] = monogrammingBackItem;
                    }
                }
                return obj;
            }, {});
            allParts = Object.assign(Object.assign({}, allParts), partDetails);
        }
        return allParts;
    };
    const generateVisualProperties = (bundleGroup, index, groupPrefix, isAddOns, isGiftSet) => {
        let allParts = {};
        const bundleTitle = bundleComponents[index].product.original_title;
        if (isGiftSet) {
            allParts[`_${groupPrefix}_giftset`] = `${bundleTitle}`;
        }
        for (const component in bundleGroup) {
            const bundleItems = isAddOns ? bundleGroup.products.filter((product) => product.part != 'parent-product') : bundleGroup[component];
            const partDetails = bundleItems.reduce((obj, item) => {
                var _a, _b, _c, _d;
                const includeSurcharge = item.selectedVariant.surcharge_price && Number(item.selectedVariant.surcharge_price) > 0;
                obj[`${groupPrefix ? `${groupPrefix}: ` : ''}${convertToTitleCase(item.part)}`] = `${item.selectedVariant.title}${includeSurcharge ? ` (+${formatCurrency(item.selectedVariant.surcharge_price * 100)})` : ''}`;
                if (item.monogramming && item.monogramming.included) {
                    const selectedEmoji = (_a = item.monogramming.emojis) === null || _a === void 0 ? void 0 : _a.find((emoji) => emoji.selected);
                    const includeMonogram = ((_b = item.monogramming.value) === null || _b === void 0 ? void 0 : _b.length) > 0;
                    if (selectedEmoji) {
                        obj[`${groupPrefix ? `${groupPrefix}: ` : ''}Emoji`] = `${selectedEmoji.name}${!includeMonogram ? (item.monogramming.price == 0 ? '' : ` (+${formatCurrency(item.monogramming.price)})`) : ''}`;
                    }
                    if (includeMonogram) {
                        obj[`${groupPrefix ? `${groupPrefix}: ` : ''}Monogram`] = `${item.monogramming.value}${item.monogramming.price == 0 ? '' : ` (+${formatCurrency(item.monogramming.price)})`}`;
                    }
                    if (selectedEmoji || includeMonogram) {
                        obj[`_${groupPrefix ? `${groupPrefix}_` : ''}monogram-details`] = `${bundleTitle}___${item.selectedVariant.title}`;
                    }
                }
                if (item.monogramming_back && item.monogramming_back.included) {
                    const selectedEmoji = (_c = item.monogramming_back.emojis) === null || _c === void 0 ? void 0 : _c.find((emoji) => emoji.selected);
                    const includeMonogram = ((_d = item.monogramming_back.value) === null || _d === void 0 ? void 0 : _d.length) > 0;
                    if (selectedEmoji) {
                        obj[`${groupPrefix ? `${groupPrefix}: ` : ''}Emoji Back`] = `${selectedEmoji.name}${!includeMonogram ? (item.monogramming_back.price == 0 ? '' : ` (+${formatCurrency(item.monogramming_back.price)})`) : ''}`;
                    }
                    if (includeMonogram) {
                        obj[`${groupPrefix ? `${groupPrefix}: ` : ''}Monogram Back`] = `${item.monogramming_back.value}${item.monogramming_back.price == 0 ? '' : ` (+${formatCurrency(item.monogramming_back.price)})`}`;
                    }
                    if (selectedEmoji || includeMonogram) {
                        obj[`_${groupPrefix ? `${groupPrefix}_` : ''}monogram-details-back`] = `${bundleTitle}___${item.selectedVariant.title}`;
                    }
                }
                return obj;
            }, {});
            allParts = Object.assign(Object.assign({}, allParts), partDetails);
        }
        return allParts;
    };
    const sortComponents = (componentData) => {
        const entries = Object.entries(componentData);
        entries.sort((a, b) => {
            const indexA = a[1].properties['_customiser-part'].split('___')[2];
            const indexB = b[1].properties['_customiser-part'].split('___')[2];
            return indexA.localeCompare(indexB, undefined, { numeric: true });
        });
        return Object.fromEntries(entries);
    };
    const sortPartsByNumberAndPartOrder = (obj) => {
        // Helper function to extract the number and part name
        const extractPartInfo = (key) => {
            const parts = key.split(': ');
            let partName = parts.length > 1 ? parts[1].toLowerCase() : key.toLowerCase(); // Handle cases with and without numbers
            let number = parts.length > 1 ? giftSetPrefix.indexOf(parts[0]) + 1 : 0; // If no number, assume 0
            if (key.includes('giftset')) {
                partName = 'giftset';
                number = key.split('_')[1];
            }
            return { number, partName };
        };
        // Custom sorting function
        const compareKeys = (keyA, keyB) => {
            const { number: numA, partName: partA } = extractPartInfo(keyA);
            const { number: numB, partName: partB } = extractPartInfo(keyB);
            // Compare by number first
            if (numA !== numB) {
                return numA - numB;
            }
            // Compare by partOrder array
            const partAIndex = partOrder.findIndex((part) => partA.includes(part));
            const partBIndex = partOrder.findIndex((part) => partB.includes(part));
            // If part names are not in the partOrder, sort alphabetically
            if (partAIndex === -1 && partBIndex === -1) {
                return partA.localeCompare(partB);
            }
            return partAIndex - partBIndex;
        };
        // Sort object keys
        const sortedKeys = Object.keys(obj).sort(compareKeys);
        // Rebuild sorted object
        const sortedObj = {};
        sortedKeys.forEach((key) => {
            sortedObj[key] = obj[key];
        });
        return sortedObj;
    };
    const triggerAddToCart = () => __awaiter(void 0, void 0, void 0, function* () {
        setAddingToCart(true);
        const cartState = [];
        const timestamp = Date.now();
        let allPartProperties = {};
        let allPartsDisplay = {};
        const isGroupSet = currentBundle.length > 1;
        currentBundle.forEach((bundleGroup, groupIndex) => {
            const allParts = addBundleComponents(bundleGroup, groupIndex, timestamp, false);
            allPartProperties = Object.assign(Object.assign({}, allPartProperties), allParts);
            const allPartlabels = generateVisualProperties(bundleGroup, groupIndex, isGroupSet ? giftSetPrefix[groupIndex] : null, false, isGroupSet);
            allPartsDisplay = Object.assign(Object.assign({}, allPartsDisplay), allPartlabels);
        });
        const sortedParts = sortComponents(allPartProperties);
        const sortedDisplay = sortPartsByNumberAndPartOrder(allPartsDisplay);
        // Add the base component
        if (product.has_components) {
            // Component Product
            const itemToAdd = {
                id: product.variant_id,
                quantity: 1,
                properties: Object.assign(Object.assign({}, sortedDisplay), { _thumbnail: thumbnailArtwork, _custom_image: checkoutImage, '_customiser-base': 'base' }),
            };
            if (Object.keys(sortedParts).length > 0) {
                itemToAdd.properties['_components'] = sortedParts;
            }
            cartState.push(itemToAdd);
        }
        else {
            // Base Component with Monogramming
            let selectedVariant;
            for (const key in currentBundle[0]) {
                const components = currentBundle[0][key];
                for (const component of components) {
                    if (component.selectedVariant) {
                        selectedVariant = component.selectedVariant;
                        break;
                    }
                }
            }
            const itemToAdd = {
                id: selectedVariant.id,
                quantity: 1,
                properties: Object.assign(Object.assign({}, sortedDisplay), { _thumbnail: thumbnailArtwork, _custom_image: checkoutImage, '_customiser-base': 'base' }),
            };
            if (Object.keys(sortedParts).length > 0) {
                itemToAdd.properties['_components'] = sortedParts;
            }
            cartState.push(itemToAdd);
        }
        // ADD ONS
        currentAddOns.forEach((addOn, index) => {
            const allAddOnProperties = addBundleComponents(addOn, 0, timestamp, true);
            const allAddOnDisplay = generateVisualProperties(addOn, 0, null, true, false);
            const sortedAddOnDisplay = sortPartsByNumberAndPartOrder(allAddOnDisplay);
            const sortedAddOnParts = sortComponents(allAddOnProperties);
            const addOnBase = addOn.products.find((product) => product.part == 'parent-product');
            const itemToAdd = {
                id: addOnBase.selectedVariant.id,
                quantity: 1,
                properties: Object.assign(Object.assign({}, sortedAddOnDisplay), { '_customiser-base': 'add-on-base', _custom_image: checkoutImage, _thumbnail: addOnArtwork[index] }),
            };
            if (Object.keys(sortedAddOnParts).length > 0) {
                itemToAdd.properties['_components'] = sortedAddOnParts;
            }
            cartState.push(itemToAdd);
        });
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = cartUtil.fetchConfig('javascript');
        const getSectionsToRender = () => {
            return [
                {
                    id: 'cart-drawer',
                    selector: '#CartDrawer',
                },
                {
                    id: 'cart-icon-bubble',
                },
            ];
        };
        const formData = {
            items: cartState,
        };
        if (cart) {
            formData['sections'] = getSectionsToRender().map((section) => section.id);
            formData['sections_url'] = window.location.pathname;
        }
        config['body'] = JSON.stringify(formData);
        fetch(window.Shopify.routes.root + 'cart/add.js', config)
            .then((response) => response.json())
            .then((response) => {
            if (cart) {
                cart.renderContents(response);
            }
            setAddingToCart(false);
            const newID = generateUID();
            setUniqueID(newID);
            closeModal();
        })
            .catch((e) => {
            console.error(e);
            setAddingToCart(false);
            closeModal();
        });
    });
    if (totalPrice == null)
        return null;
    return (React.createElement("div", { className: `fg-cust--add-to-cart ${extraClass}` },
        OOSMessage != '' && (React.createElement("div", { className: "fg-cust--add-to-cart__oos-message", dangerouslySetInnerHTML: { __html: OOSMessage } })),
        React.createElement("div", { className: "fg-cust--add-to-cart__btn-wrapper" },
            openModal && showCustomiseButton ? (React.createElement("button", { className: "fg-cust--customise-btn", onClick: openModal },
                React.createElement("div", { className: "badge__inner" }, strings.customise_title))) : null,
            React.createElement("button", { className: "fg-cust--add-to-cart__btn", onClick: triggerAddToCart, disabled: disabled || addingToCart || disableBannedWord }, addingToCart ? (React.createElement("div", { className: "loader" })) : (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "fg-cust--add-to-cart-btn__message" }, disabled || disableBannedWord ? strings.sold_out + ' — ' : strings.add_to_cart + ' — '),
                React.createElement("span", { className: "fg-cust--add-to-cart-btn__price" }, formatCurrency(totalPrice)),
                comparePrice > totalPrice && React.createElement("span", { className: "fg-cust--add-to-cart-btn__compare" }, formatCurrency(comparePrice))))))));
};
export default AddToCartButton;
